import Highcharts from 'highcharts';

export const createDefaultScrollbarOptions = (
): Highcharts.ScrollbarOptions => ({
  enabled: false,
});
